import { render, staticRenderFns } from "./Container2.vue?vue&type=template&id=1ae92960&scoped=true"
import script from "./Container2.vue?vue&type=script&lang=js"
export * from "./Container2.vue?vue&type=script&lang=js"
import style0 from "./Container2.vue?vue&type=style&index=0&id=1ae92960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae92960",
  null
  
)

export default component.exports